<template>
  <div>
    <video controls>
      <source :src="content.url" type="video/mp4" />
    </video>
  </div>
</template>

<script>
  import { Props, Computed } from '../../assets/js/mixins';
  
  export default {
    mixins: [Props, Computed],
    data() {
      return {
        
      }
    }
  }
</script>

<<style lang="scss" scoped>
video {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  position: relative; 
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
</style>




// WEBPACK FOOTER //
// src/components/video/Video.vue